import CmsService from "./cms-service";

const cms = new CmsService();
cms.handlePreviewing();
export default cms;
